'use client'

import { Alert } from 'antd'
import { detect } from 'detect-browser'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { captureException } from '@tucan/utils/error-tracking'

interface Browser {
  name: string
  version: string
  os: string
  type: string
}

export const LegacyBrowserWarning: React.FC = () => {
  const [browser, setBrowser] = React.useState<Browser>({
    name: '',
    os: '',
    type: '',
    version: '',
  })
  const { t } = useTranslation()

  React.useEffect(() => {
    const b = detect()
    setBrowser({
      name: b?.name ?? '',
      os: b?.os ?? '',
      type: b?.type ?? '',
      version: b?.version ?? '',
    })
  }, [])

  const showAlert = useMemo(() => {
    if (!browser.name) {
      return false
    }

    try {
      return (
        (browser.name === 'chrome' && parseInt(browser.version) < 83)
        || (browser.name === 'safari' && parseInt(browser.version) < 12)
        || (browser.name === 'edge' && parseInt(browser.version) < 83)
        || (browser.name === 'firefox' && parseInt(browser.version) < 66)
        || browser.name === 'ie'
      )
    } catch (e) {
      captureException(e)
      return true
    }
  }, [browser])

  return (
    <>
      <Alert
        id={'browser-warning'}
        banner
        title={
          <div>
            {t('old-browser-warning', 'You are using an outdated browser. You can update your browser')}
          </div>
        }
        style={{
          display: showAlert ? undefined : 'none',
        }}
        type="error"
      />
      <noscript dangerouslySetInnerHTML={{ __html: `
        <style>
          #browser-warning {
            display: flex !important;
          }
        </style>
      `}} />
    </>
  )
}
